import * as React from "react";
import { SVGProps } from "react";
const SvgSnowflake = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 32 32" {...props}>
    <g clipPath="url(#snowflake_svg__a)">
      <path
        fill="currentColor"
        d="m30.7 17.1-7.3 2L18 16l5.4-3.1 7.3 2 .5-2-5.4-1.4 4.6-2.6-1-1.8-4.6 2.7 1.5-5.4-2-.6-1.9 7.4-5.4 3.1V8.1l5.4-5.4L21 1.3l-4 3.9V0h-2v5.2l-4-3.9-1.4 1.4L15 8.1v6.2l-5.4-3.1-1.9-7.4-2 .6 1.5 5.4-4.6-2.7-1 1.8 4.6 2.6-5.4 1.4.5 2 7.3-2L14 16l-5.4 3.1-7.3-2-.5 2 5.4 1.4-4.6 2.6 1 1.8 4.6-2.7-1.5 5.4 2 .6 1.9-7.4 5.4-3.1v6.2l-5.4 5.4 1.4 1.4 4-3.9V32h2v-5.2l4 3.9 1.4-1.4-5.4-5.4v-6.2l5.4 3.1 1.9 7.4 2-.6-1.5-5.4 4.6 2.7 1-1.8-4.6-2.6 5.4-1.4-.5-2Z"
      />
    </g>
    <defs>
      <clipPath id="snowflake_svg__a">
        <path fill="#fff" d="M0 0h32v32H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgSnowflake;
